<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">Задачи</div>
                  <div class="breadcrumb">Монитор продаж / Задачи</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-col>
          <v-sheet
              rounded="lg"
          >
            <v-card-title
                class="custom__card-title"
            >
              <div class="search_client">
                <v-text-field
                    v-model="search"
                    rounded
                    outlined
                    dense
                    hide-details
                    single-line
                    label="Поиск"
                    style="font-size: 12px;font-weight: normal"
                    background-color="white"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="filter_client">
                <v-btn
                    dark
                    class="filter-button"
                    :disabled="isLoading"
                    @click="dialogFiler = !dialogFiler"
                >
                  <img
                      class="mr-1"
                      src="/playground_assets/mediumfilter.svg"
                  >
                  Фильтр
                </v-btn>
              </div>

            </v-card-title>
            <v-card-text
                v-show="dialogFiler"
            >
              <v-container>
                <v-row>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Статус</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.status"
                        :items="statusTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Вид взаимодействия</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.type_action"
                        :items="comunityTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Вид сделки</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.type_deal"
                        :items="dealsTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Этап</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.stage"
                        :items="stageTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение"
                        append-icon="mdi-chevron-down"
                        outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <!-- <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Контрагент</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.counterparty"
                        :items="list.monitor"
                        item-value="user.id"
                        item-text="user.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col> -->
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Статус клиента</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.status_client"
                        :items="statusClientTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                    
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Исполнитель</label>
                    <v-select
                      v-if="managersList && managersList.managers"
                                v-model="tasksFilter.user"
                                :items="managersList.managers"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Кто выполнил</label>
                    <v-select
                      v-if="specialist && specialist.specialist"
                                v-model="tasksFilter.doneuser"
                                :items="specialist.specialist"
                                no-data-text="Нет доступных менеджеров"
                                item-text="name"
                                item-value="id"
                                class="rounded-lg"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                required
                                color="#629F33"
                                return-object
                            ></v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Сделка</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.deal"
                        :items="bueTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Клубы</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.club"
                        :items="clubTypes"
                        item-value="id"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Пометка удаления</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="tasksFilter.deletion"
                        :items="deletionTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-card-actions class="mt-4">
                    <template v-if="!dialogButton">
                      <button
                          class="button custom__button mt-5"
                          type="button"
                          @click="returnTasks"
                      >
                        Применить
                      </button>
                    </template>
                    <template v-else>
                      <button
                          class="button custom__button mt-5"
                          type="button"
                          @click="filterTasks(tasksFilter)"
                          style="background-color: #A13453 !important;color: #fff !important;"
                      >
                        Применить
                      </button>
                      <button
                          class="button custom__button mt-5 ml-3"
                          type="button"
                          style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                          @click="clearData"
                      >
                        Сбросить фильтр
                      </button>
                    </template>
                  </v-card-actions>
                </v-row>
              </v-container>
            </v-card-text>
            <v-data-table
                v-if="list && list.monitor && !isLoading"
                    :headers="headersTasks"
                    :items="list.monitor"
                    no-data-text="Результатов не найдено"
                    :hide-default-footer="true"
                    :page="page"
                    class="elevation-1"
                    :server-items-length="list.monitor.listLength"
                    :items-per-page="toggle_exclusive"
            >
              <template v-slot:item.client.name="{ item }">
                <router-link
                    :to="{ name: 'CardClientNew', params: {client_id: item.client.id}}"
                    class="d-flex"
                    style="align-items: center; text-decoration: none; color: #000"
                >
                  {{ item.client.name }}
                </router-link>
              </template>
              <template v-slot:item.deal.name="{ item }">
                <span :style="item.deal.name ? '' : 'color: red'">{{ item.deal.name ? item.deal.name : 'Без сделки' }}</span>
              </template>
              <template v-slot:item.date="{ item }">
                {{ formatDate(item.date) }}
              </template>
              <template v-slot:item.enddate="{ item }">
                {{ formatDate(item.enddate) }}
              </template>
              <template v-slot:item.donedate="{ item }">
                {{ item.donedate ? formatDate(item.donedate) : null }}
              </template>
            </v-data-table>

       


            
            <!-- <v-card-actions
                class="d-flex justify-content-between"
                style="padding: 20px !important;"
            >
              <template>
                <div></div>
                <div>
                  <v-pagination
                      v-model="page"
                      circle
                      color="#629F33"
                      :total-visible="4"
                      :length="Math.ceil(list.monitor.length / 10)"
                  ></v-pagination>
                </div>
              </template>
            </v-card-actions> -->
            <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="list && list.listLength">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ list.listLength }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="list.paginationLength"
                            :total-visible="8"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>
          </v-sheet>

        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {monitorActionTypes} from "@/store/modules/monitor";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {organizationActionTypes} from '@/store/modules/organization';
import {lessonActionTypes} from "@/store/modules/lesson";

export default {
  name: 'TasksPage',
  props: ['specialistType', 'type', 'specialist_id', 'startdate', 'enddate'],
  components: {
    Header,
    Menu,
  },
  computed: {
    ...mapState({
      isLoading: state => state.monitor.isLoading,
      list: state => state.monitor.list,
      validationErrors: state => state.monitor.validationErrors,
      managersList: state => state.organization.managersList,
      specialist: state => state.lesson.specialist
    })
  },
  methods: {
    fetchFeed(specialist_id, type, startdate, enddate, search, filter) {
      
      let page = this.page
      let limit = this.toggle_exclusive

      let client_search = search ? search : null
      let task_filter = filter ? filter : null

      setItem('task-filter_obj', JSON.stringify(task_filter))

      if (type === 'overdue') {
        this.$store.dispatch(monitorActionTypes.getOverdueTasks, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          task_filter
        })
      } else {
        this.$store.dispatch(monitorActionTypes.getNewTasks, {
          specialist_id,
          startdate,
          enddate,
          page,
          limit,
          client_search,
          task_filter
        })
      }
    },
    collectData(selected) {
      this.selected.push(selected)
      // if (this.selected !== [] || this.dealsFilter.date_creation !== null || this.dealsFilter.date_end !== null || this.dealsFilter.date_schedule !== null) {
      //   this.dialogButton = true;
      // }
    },
    clearData() {
      this.selected.length = 0;
      this.tasksFilter.status = null;
      this.tasksFilter.type_action = null;
      this.tasksFilter.type_deal = null;
      this.tasksFilter.stage = null;
      this.tasksFilter.counterparty = null;
      this.tasksFilter.status_client = null;
      this.tasksFilter.user = null;
      this.tasksFilter.doneuser = null;
      this.tasksFilter.deal = null;
      this.tasksFilter.club = null;
      this.tasksFilter.deletion = null;
      this.dialogButton = true;
    },
    filterTasks(tasks) {
      console.log(tasks)
      this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
      // if (tasks.status !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.client.status === tasks.status);
      // }
      // if (tasks.type_action !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.type === tasks.type_action);
      // }
      // if (tasks.type_deal !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.deal.type.id === tasks.type_deal);
      // }
      // if (tasks.stage !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.deal.stage.id === tasks.stage);
      // }
      // if (tasks.counterparty !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.client.id === tasks.counterparty);
      // }
      // if (tasks.status_client !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.client.status === tasks.status_client);
      // }
      // if (tasks.user !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.user.id === tasks.user);
      // }
      // if (tasks.doneuser !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.doneuser.id === tasks.doneuser);
      // }
      // if (tasks.deal !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.deal.id === tasks.deal);
      // }
      // if (tasks.club !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.club.id === tasks.club);
      // }
      // if (tasks.deletion !== null) {
      //   this.list.monitor = this.list.monitor.filter((item) => item.deletion === tasks.deletion);
      // }
    },
    returnTasks() {
     // if (this.dialogButton) {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
     // }
    },
    formatDate(date) {
      date = new Date(date);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const formattedDay = (day < 10) ? `0${day}` : day;
      const formattedMonth = (month < 10) ? `0${month}` : month;

      return `${formattedDay}.${formattedMonth}.${year}`;
    }
  },
  data() {
    return {
      search: '',
      select: null,
      selected: [],
      dialogFiler: false,
      dialogButton: true,
      valid: true,
      actionTypes: [
        {name: 'Взаимодействие 1', value: true},
        {name: 'Взаимодействие 2', value: false},
      ],
      counterpartyTypes: [
        {name: 'Контрагент 1', value: true},
        {name: 'Контрагент 2', value: false},
      ],
      statusTypes: [
        {name: 'Выполнена', value: 'Выполнена'},
        {name: 'Не выполнена', value: 'НеВыполнена'},
        {name: 'Просрочена', value: 'Просрочена'}
      ],
      stageTypes: [
        {name: 'Отказ', value: "361870a3-f7b5-11ea-8134-9c5c8e747603-0"}, //!
        {name: 'Успех', value: "361870a3-f7b5-11ea-8134-9c5c8e747603-01"}, //!
        {name: 'Контакт с клиентом', value: "361870a3-f7b5-11ea-8134-9c5c8e747603"},
        {name: 'Презентация клуба', value: "361870a4-f7b5-11ea-8134-9c5c8e747603"},
        {name: 'Пробное занятие', value: "361870a6-f7b5-11ea-8134-9c5c8e747603-02"}, //!
        {name: 'Оформление продажи', value: "361870a6-f7b5-11ea-8134-9c5c8e747603"}
      ],
      statusClientTypes: [
        {name: 'Потенциальный член клуба', value: "ПотенциальныйЧленКлуба"},
        {name: 'Клиент клуба', value: "КлиентКлуба"},
        {name: 'Член клуба', value: "ЧленКлуба"},
        {name: 'Бывший клиент клуба', value: "БывшийКлиентКлуба"},
        {name: 'Бывший член клуба', value: "БывшийЧленКлуба"},
        {name: 'Отказ', value: "Отказ"}
      ],
      comunityTypes: [
        {name: 'Встреча', value: "Встреча"},
        {name: 'Гостевое посещение', value: "ГостевоеПосещение"},
        {name: 'Звонок входящий', value: "ЗвонокВходящий"},
        {name: 'Звонок исходящий', value: "ЗвонокИсходящий"},
        {name: 'Онлайн-заявка', value: "ОнлайнЗаявка"},
        {name: 'Пробное занятие', value: "ПробноеЗанятие"},
        {name: 'Прочее', value: "Прочее"},
        {name: 'Визит', value: "Визит"},
        {name: 'Напомнить об окончании сроков карты', value: "НапомнитьОбОкончанииСроковКарты"},
        {name: 'Гость', value: "Гость"}
      ],
      dealsTypes: [
        {name: 'Новая продажа', value: "Новая продажа"},
        {name: 'Продление', value: "Продление"},
        {name: 'Не указан', value: 'Не указан'}
      ],
      bueTypes: [
        {name: 'Есть сделки', value: true},
        {name: 'Нет сделок', value: false}
      ],
      deletionTypes: [
        {name: 'Удалена', value: true},
        {name: 'Не удалена', value: false}
      ],
      clubTypes: [
        {name: 'КлеверСпорт Н.Челны', id: "2dd7fea2-587b-11ea-80e1-9c5c8e747603"}
      ],
      tasksFilter: {
        status: {name: 'Просрочена', value: 'Просрочена'},
        type_action: null,
        type_deal: null,
        stage: null,
        counterparty: null,
        status_client: null,
        user: null,
        doneuser: null,
        deal: null,
        club: {name: 'КлеверСпорт Н.Челны', id: "2dd7fea2-587b-11ea-80e1-9c5c8e747603"},
        deletion: {name: 'Не удалена', value: false}
      },
      headersTasks: [
        {text: 'Дата', align: 'start', value: 'date'},
        {text: 'Переносов', align: 'start', value: 'transfers'},
        {text: 'Клиент', align: 'start', value: 'client.name'},
        {text: 'Статус клиента', align: 'start', value: 'client.status'},
        {text: 'Сделка', value: 'deal.name'},
        {text: 'Тема', value: 'theme'},
        {text: 'Триггерное событие', value: 'trigger.name'},
        {text: 'Описание', value: 'description'},
        {text: 'Дата назначено', value: 'enddate'},
        {text: 'Исполнитель', value: 'user.name'},
        {text: 'Дата выполнения', value: 'donedate'},
        {text: 'Кто выполнил', value: 'doneuser.name'},
        {text: 'Предмет', value: 'object.name'}
      ],
      page:1,
      toggle_exclusive: 20
    }
  },
  mounted() {

    console.log(this.type)

    if(this.type === 'new'){
      this.tasksFilter.status = {name: 'Не выполнена', value: 'НеВыполнена'}
    }

    //this.isLoading = true

    if(getItem('task-filter_obj') && getItem('task-filter_obj') !== null && getItem('task-filter_obj') !== undefined && getItem('task-filter_obj') !== 'null'){

      this.tasksFilter = JSON.parse(getItem('task-filter_obj'))

    }

    if(this.specialist_id && this.specialist_id !== undefined && this.specialist_id !== null && this.specialist_id !== 'null'){
      setItem('tasks-specialist_id', this.specialist_id)
    } else {
      this.specialist_id = getItem('tasks-specialist_id')
    }

    console.log(this.specialist_id)

    this.type !== undefined ? setItem('tasks-type', this.type) : this.type = getItem('tasks-type');
    // if(this.specialistType == 0) {
    //   this.specialist_id = null
    // }
    if (this.startdate === undefined && this.enddate === undefined) {
      this.startdate = new Date();
      this.enddate = new Date();
    }

    if(getItem('tasks-specialist_id') && getItem('tasks-specialist_id') !== undefined && getItem('tasks-specialist_id') !== null && getItem('tasks-specialist_id') !== 'null'){

    } else {
      if(!this.specialistType || this.specialistType == 0) {
        this.specialist_id = null
      }
    }


    
    this.$store.dispatch(organizationActionTypes.organizationManagersList).then((response) => {
        if(this.specialist_id) {
            if(response && response.managers){
              let managerDef = response.managers.filter((item) => this.specialist_id.includes(item.id));
              if(managerDef && managerDef[0] && managerDef[0].id){
                this.tasksFilter.user = {
                  name: managerDef[0].name,
                  id: managerDef[0].id
                }

                this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
              } else {
                this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
              }
            }
        } else {
          this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
        }
    });

    

    this.$store.dispatch(lessonActionTypes.getSpecialistList);
  },
  watch: {
    toggle_exclusive() {
      this.page = 1;
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.tasksFilter);
      }
    },
    page() {
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.tasksFilter);
      } else {
        this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
      }
    },
    search() {
      if (this.search !== '') {
        this.loading = true
        this.specialist_id !== undefined ? setItem('tasks-specialist_id', this.specialist_id) : this.specialist_id = getItem('tasks-specialist_id');
    this.type !== undefined ? setItem('tasks-type', this.type) : this.type = getItem('tasks-type');
    if(this.specialistType == 0) {
      this.specialist_id = null
    }
    if (this.startdate === undefined && this.enddate === undefined) {
      this.startdate = new Date();
      this.enddate = new Date();
    }
            this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, this.search, this.tasksFilter);
        } else {
            this.loading = true
            this.specialist_id !== undefined ? setItem('tasks-specialist_id', this.specialist_id) : this.specialist_id = getItem('tasks-specialist_id');
            this.type !== undefined ? setItem('tasks-type', this.type) : this.type = getItem('tasks-type');
            if(this.specialistType == 0) {
              this.specialist_id = null
            }
            if (this.startdate === undefined && this.enddate === undefined) {
              this.startdate = new Date();
              this.enddate = new Date();
            }
            this.fetchFeed(this.specialist_id, this.type, this.startdate, this.enddate, null, this.tasksFilter);
          }
      }
  }
}
</script>
<style scoped lang="scss">
.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }

    }

  }

.hidden-block {
  padding-top: 20px;

}

&__field {

&.colspan-4 {
  grid-column: 1 / 5;
}

&.button-block {

button {

&:not(:last-child) {
  margin-right: 20px;
}

}
}

.label {
  color: #1A1A1A;
  display: block;
  margin-bottom: 8px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

}

button {
  border-radius: 12px;
  text-transform: none;
  color: #FFFFFF;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  box-shadow: none;
  padding: 13px 21px;

&.apply {
  background: #629F33 !important;
  color: #fff !important;
}

&.clear {
  background: #F1F1F1 !important;
  color: #1A1A1A !important;
}

}
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

.ava {
  margin-right: 8px;
}

}

.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}

.custom__card-title {
  justify-content: space-between;
  flex-wrap: wrap;
}

.search_client {
  min-width: 40%;
  display: flex;
  align-items: center;
}
</style>